var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2BGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.28 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.77,13.01h0c0-.07-.02-.13-.05-.18.02.05.03.11.04.18Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,73.26l-.81-.31.66-.55c3.05-2.54,4.8-6.26,4.8-10.21,0-7.47-6.08-13.54-13.54-13.54s-13.54,6.08-13.54,13.54c0,3.95,1.75,7.67,4.8,10.21l.66.55-.81.31c-9.81,3.74-16.15,12.93-16.15,23.41v1.28c0,1.13.92,2.05,2.05,2.05h45.98c1.13,0,2.05-.92,2.05-2.05v-1.28c0-10.48-6.34-19.67-16.15-23.41ZM71.79,62.19c0-5.3,4.15-9.45,9.45-9.45s9.45,4.15,9.45,9.45-4.15,9.45-9.45,9.45-9.45-4.15-9.45-9.45ZM60.27,95.9l.03-.54c.66-11.01,9.85-19.63,20.94-19.63s20.28,8.62,20.94,19.63l.03.54h-41.94Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44,87.19c-.08-.1-.12-.19-.14-.33-.03-.04-.06-.08-.08-.13l-10.64-10.64c-.83-.83-2.03-.83-2.86,0-.83.83-.83,2.03,0,2.86l6.74,6.74h-18.58v-23.5c0-1.13-.92-2.05-2.05-2.05s-2.05.92-2.05,2.05v25.55c0,1.13.92,2.05,2.05,2.05h20.51l-6.74,6.74c-.83.83-.83,2.03,0,2.86.8.8,2.06.8,2.86,0l10.73-10.73s.02-.03.03-.05c.03-.05.1-.15.21-.24v-.03s.15-.25.15-.25c.08-.24.09-.38.03-.6-.08-.09-.14-.18-.16-.3Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.93,24.73l-.81-.31.66-.55c3.05-2.54,4.8-6.26,4.8-10.21C38.58,6.18,32.51.11,25.04.11s-13.54,6.08-13.54,13.54c0,3.95,1.75,7.67,4.8,10.21l.66.55-.81.31C6.34,28.47,0,37.66,0,48.14v1.28c0,1.13.92,2.05,2.05,2.05h45.98c1.13,0,2.05-.92,2.05-2.05v-1.28c0-10.48-6.34-19.67-16.15-23.41ZM15.59,13.65c0-5.3,4.15-9.45,9.45-9.45s9.45,4.15,9.45,9.45-4.15,9.45-9.45,9.45-9.45-4.15-9.45-9.45ZM46.01,47.37H4.07l.03-.54c.66-11.01,9.85-19.63,20.94-19.63s20.28,8.62,20.94,19.63l.03.54Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.34,23.77c.83-.83.83-2.03,0-2.86l-6.74-6.74h18.58v23.5c0,1.13.92,2.05,2.05,2.05s2.05-.92,2.05-2.05V12.25c0-1.13-.92-2.05-2.05-2.05h-20.51l6.74-6.74c.4-.4.62-.91.62-1.43s-.22-1.03-.62-1.43c-.8-.8-2.07-.8-2.86,0l-10.51,10.51c-.03.06-.06.11-.09.15-.02.1-.07.17-.11.23v.08l-.13.13v.08s-.15.25-.15.25c-.08.24-.09.38-.03.6.05.06.1.12.13.19.06.07.16.19.18.37l10.59,10.59c.8.8,2.06.8,2.86,0Z",
    fill: "#2cc749"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BGreen);
export default __webpack_public_path__ + "static/media/b2b-green.f8683ec60d56e154b063a98b1b7510e7.svg";
export { ForwardRef as ReactComponent };